export default "__VITE_ASSET__f4e3ef29__"